import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { FileText, RotateCcw } from "lucide-react";
import PatientRecordLink from "../PatientRecordLink";
import { patientRecordLabel, resolvePatientRecordId } from "../../lib/patientRecordId";
import { toast } from "sonner";

export default function PendingFollowUpsCard({ suggestions = [], drafts = [], showcaseMode = false }) {
  const followUps = Array.isArray(suggestions) ? suggestions : [];
  const draftList = Array.isArray(drafts) ? drafts : [];

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="dashboard-visual-follow-ups">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900">
          <RotateCcw className="h-5 w-5 text-sky-700" />
          Pendientes
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <section>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Reconsultas y seguimiento</p>
          {followUps.length === 0 ? (
            <p className="mt-2 text-sm text-slate-600">
              No hay pacientes que requieran seguimiento en este momento.
            </p>
          ) : (
            <ul className="mt-2 space-y-2">
              {followUps.slice(0, 5).map((item, index) => {
                const recordId = resolvePatientRecordId(item);
                return (
                  <li key={recordId || `follow-${index}`}>
                    {showcaseMode ? (
                      <button
                        type="button"
                        className="block w-full text-left rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 hover:border-sky-200"
                        onClick={() => toast.info("Disponible en la plataforma autenticada.")}
                      >
                        <p className="text-sm font-medium text-slate-900">{patientRecordLabel(item)}</p>
                        <p className="text-xs text-slate-500">{item.type || item.motivo || item.reason || "Seguimiento"}</p>
                      </button>
                    ) : (
                      <PatientRecordLink
                        record={item}
                        className="block rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 hover:border-sky-200"
                      >
                        <p className="text-sm font-medium text-slate-900">{patientRecordLabel(item)}</p>
                        <p className="text-xs text-slate-500">{item.type || item.motivo || item.reason || "Seguimiento"}</p>
                      </PatientRecordLink>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </section>

        <section>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Borradores pendientes</p>
          {draftList.length === 0 ? (
            <p className="mt-2 text-sm text-slate-600">No hay consultas en borrador.</p>
          ) : (
            <ul className="mt-2 space-y-2">
              {draftList.slice(0, 5).map((draft, index) => {
                const patientId = draft.paciente_id || draft.patient_id;
                const label = draft.paciente_nombre || draft.patient_name || "Consulta en progreso";
                const href = patientId ? `/nueva-consulta/${patientId}` : "/nueva-consulta";
                return (
                  <li key={draft.id || `draft-${index}`}>
                    {showcaseMode ? (
                      <button
                        type="button"
                        className="flex w-full text-left items-center gap-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-sm text-slate-800 hover:border-sky-200"
                        onClick={() => toast.info("Disponible en la plataforma autenticada.")}
                      >
                        <FileText className="h-4 w-4 text-sky-700" />
                        {label}
                      </button>
                    ) : (
                      <Link
                        to={href}
                        className="flex items-center gap-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-sm text-slate-800 hover:border-sky-200"
                      >
                        <FileText className="h-4 w-4 text-sky-700" />
                        {label}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      </CardContent>
    </Card>
  );
}
